<script lang="ts">
  import { Title, Form, Input, ConfirmActions } from '$shared/components';
  import { onMount } from 'svelte';

  interface Props {
    folderName?: string;
    loading?: boolean;
    error?: string;
    onevent?: (payload: any) => void;
  }

  let { folderName = '', loading = false, error = $bindable(''), onevent }: Props = $props();

  let newFolderName = $state('');
  let localError = $state('');

  onMount(() => {
    newFolderName = folderName;
  });

  const onClickCancel = (): void => {
    onevent?.({ type: 'close' });
  };

  const onClickOk = (): void => {
    if (!newFolderName || newFolderName === folderName) {
      localError = 'Folder name cannot be empty or no change made';
      return;
    }
    localError = '';
    onevent?.({ type: 'ok', data: { updatedName: `${newFolderName}` } });
  };

  const onInputChange = (detail: { value: string }): void => {
    newFolderName = detail.value.trim();
  };

  const onClickCloseError = (): void => {
    error = '';
    localError = '';
  };
</script>

<div class="rename-file">
  <div class="title"><Title type="h3">Rename folder</Title></div>
  <div class="form">
    <Form error={error || localError} onalertclose={onClickCloseError}>
      <div class="input">
        <Input name="renameInput" value={newFolderName} oninput={onInputChange} />
      </div>
      <div class="actions">
        <ConfirmActions {loading} okLabel="Rename" oncancel={onClickCancel} onok={onClickOk} />
      </div>
    </Form>
  </div>
</div>

<style>
  .rename-file {
    padding: 24px;
  }

  .form,
  .actions {
    margin-top: 24px;
  }

  .input {
    display: flex;
    align-items: center;
  }
  .input .ext {
    margin-left: 8px;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
  }
</style>
